import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const CouponLink = z.object({
  kind: z.union([z.literal('html'), z.literal('image')]),
  url: z.string().url(),
})

export type CouponLink = z.infer<typeof CouponLink>

export const GenerateCouponLinkRequest = z.object({
  tag: z.string(),
  email: z.string().email(),
  language: z.string().default('en'),
})

export type GenerateCouponLinkRequest = z.infer<typeof GenerateCouponLinkRequest>

export const GenerateCouponLinkResponse = z.object({
  status: z.literal('generated'),
  link: CouponLink,
})

export type GenerateCouponLinkResponse = z.infer<typeof GenerateCouponLinkResponse>

export const generateCouponLinkDeclaration = endpointDeclaration(GenerateCouponLinkRequest, GenerateCouponLinkResponse)
